import axios from 'utils/axios';

export const getServicePackages = (query?: string, group?: string, status?: string, categoryBenefitsId?: string) => {
  return axios.get(`/api/v1/servicepackages/mfo`, {
    params: { query, status, groupId: group || null, categoryBenefitsId: categoryBenefitsId || null },
  });
};
